import BaseModelAPI from '../BaseModelAPI';

export default class ReportRekapDelivery extends BaseModelAPI {
	static entity = 'newreport1996';
	static entityName = 'reportrekapdelivery';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.filterCustomer = '';
			this.filterPart = '';
			this.filterPoNoCustomer = '';
			this.filterSuratJalanNumber = '';
			this.filterDiDeliveryDate = '';
			this.tempId = 0;
			this.deliveryDate = '';
			this.suratJalanNumber = '';
			this.poNoCustomer = '';
			this.partNumber = '';
			this.partName = '';
			this.deliveryQty = 0;
			this.customerName = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}